import { getToken, getTokenAud } from '@sit/client-shared';
import { config } from '@web/config/env';
import { authStore } from '@web/redux/auth-store';
import { useEffect } from 'react';

export function useForceLogoutSITWeb() {
  const token = getToken();
  const aud = getTokenAud(token);
  useEffect(() => {
    if (aud === 'sit' && !config.loginEnabled) {
      // Standalone SIT web in production doesn't allow login, so we force logout.
      authStore.logout();
    }
  }, [aud]);
}
